import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip
} from '@mui/material';
import { Box } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

// table component
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DateRange } from 'react-date-range';
import { MdOutlinePreview, MdUploadFile, MdUpload, MdOutlineAdd } from 'react-icons/md';

import { fDate } from '../../utils/formatTime';
import { UserMoreMenu } from '../../components/_dashboard/user';

function VolumeCommission({
  StyledTableCell,
  StyledTableRow,
  setOpen2,
  setValidationMsg2,
  volumeArray,
  setVolumeArray,
  volumeArrayList,
  setVolumeArrayList,
  loanTypesList,
  branches,
  setDeleteConfirm2,
  setVolumeCommissionEdit,
  volumeEditDialogOpen,
  volumeDeleteDialogOpen
}) {
  const [commissionDateRange, setCommissionDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);

  const handleAddVolume = () => {
    if (volumeArray.loanType === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select loan type');
      return;
    }

    if (volumeArray.branch === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select branch');
      return;
    }

    if (volumeArray.amount === '') {
      setOpen2(true);
      setValidationMsg2('Please enter amount');
      return;
    }

    if (volumeArray.duration === '') {
      setOpen2(true);
      setValidationMsg2('Please enter duration');
      return;
    }

    if (volumeArray.commission === '') {
      setOpen2(true);
      setValidationMsg2('Please enter commission');
      return;
    }

    if (volumeArray.unit === '') {
      setOpen2(true);
      setValidationMsg2('Please enter unit');
      return;
    }

    if (Number(volumeArray.commission) > 100) {
      setOpen2(true);
      setValidationMsg2('Please enter valid commission %');
      return;
    }

    const newLoanName = JSON.parse(volumeArray.loanType).loanName;
    const newBranchName = JSON.parse(volumeArray.branch).branchName;

    const alreadyExists = volumeArrayList.some(
      (item) =>
        JSON.parse(item.loanType).loanName === newLoanName &&
        JSON.parse(item.branch).branchName === newBranchName
    );

    if (alreadyExists) {
      setOpen2(true);
      setValidationMsg2('Loan Name already exists - Please try entering with another Loan Name');
      return;
    }

    const newCommission = {
      ...volumeArray,
      isIndividualCommissionType: false,
      aggrementCommissionId: null
    };

    setVolumeArrayList((prev) => [...prev, newCommission]);

    setVolumeArray({
      loanType: ' ',
      branch: ' ',
      amount: '',
      duration: '',
      commission: '',
      unit: '',
      isIndividualCommissionType: null,
      aggrementCommissionId: null
    });
  };

  return (
    <Box className="">
      <Box className="viewLeadCard" mb={3}>
        <Grid container spacing={3} mb={3}>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Loan Type
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${volumeArray.loanType}`
                }}
                value={volumeArray.loanType}
                onChange={(e) => {
                  setVolumeArray((prev) => ({
                    ...prev,
                    loanType: e.target.value
                  }));
                }}
              >
                <MenuItem value=" ">Select Loan Type</MenuItem>
                {loanTypesList.length > 0
                  ? loanTypesList.map((item, index) => {
                      const itemValue = {
                        loanId: item.loanId,
                        loanName: item.loanName
                      };
                      return (
                        <MenuItem value={JSON.stringify(itemValue)} key={index}>
                          {item.loanName}
                        </MenuItem>
                      );
                    })
                  : ''}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Branch
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${volumeArray.branch}`
                }}
                value={volumeArray.branch}
                onChange={(e) => {
                  setVolumeArray((prev) => ({
                    ...prev,
                    branch: e.target.value
                  }));
                }}
              >
                <MenuItem value=" ">Select Branch</MenuItem>
                {branches !== undefined && branches.length > 0
                  ? branches.map((item, index) => {
                      const itemValue = {
                        branchId: item.branchId,
                        branchName: item.branchName
                      };
                      return (
                        <MenuItem value={JSON.stringify(itemValue)} key={index}>
                          {item.branchName}
                        </MenuItem>
                      );
                    })
                  : ''}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Amount
              </Typography>
              <TextField
                type="number"
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Amount"
                value={volumeArray.amount}
                onChange={(e) => {
                  setVolumeArray((prev) => ({
                    ...prev,
                    amount: e.target.value
                  }));
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Duration
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Duration"
                value={volumeArray.duration}
                onChange={(e) => {
                  setVolumeArray((prev) => ({
                    ...prev,
                    duration: e.target.value
                  }));
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Commission %
              </Typography>
              <TextField
                type="number"
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Commission"
                value={volumeArray.commission}
                onChange={(e) => {
                  setVolumeArray((prev) => ({
                    ...prev,
                    commission: e.target.value
                  }));
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box>
              <Typography variant="h6" className="formLabel">
                Date Range
              </Typography>

              <Box className="displayDateRange" sx={{ mb: 1 }}>
                {volumeArray.startDate ? `${fDate(volumeArray.startDate)} to ` : ''}
                {volumeArray.endDate ? fDate(volumeArray.endDate) : ''}
                {!volumeArray.startDate && !volumeArray.endDate && (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                )}
              </Box>

              <Select
                fullWidth
                value=" "
                className="datesSelect"
                inputProps={{ className: 'textInput' }}
                MenuProps={{ className: 'menuOpened' }}
              >
                <DateRange
                  editableDateInputs={false}
                  onChange={(item) => setCommissionDateRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={commissionDateRange}
                />
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box>
              <Typography variant="h6" className="formLabel">
                Unit
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Unit"
                sx={{ marginRight: '1rem' }}
                value={volumeArray.unit}
                onChange={(e) => {
                  setVolumeArray((prev) => ({
                    ...prev,
                    unit: e.target.value
                  }));
                }}
              />
            </Box>
          </Grid>
        </Grid>
        <Box textAlign="right">
          <Button
            className="mainBtn otherBtn"
            variant="contained"
            onClick={(e) => handleAddVolume(e)}
          >
            Add Commission
          </Button>
        </Box>
      </Box>
      <Box className="greenBorder tableBox">
        <TableContainer sx={{ minWidth: 800, overflow: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Loan Type</StyledTableCell>
                <StyledTableCell align="">Branch</StyledTableCell>
                <StyledTableCell align="">Amount</StyledTableCell>
                <StyledTableCell align="">Duration</StyledTableCell>
                <StyledTableCell align="">Commission %</StyledTableCell>
                <StyledTableCell align="">Unit</StyledTableCell>
                <StyledTableCell align="" width={80}>
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {volumeArrayList &&
                volumeArrayList.map((item, index) => (
                  <StyledTableRow>
                    <StyledTableCell align="left">
                      {JSON.parse(item.loanType).loanName}
                    </StyledTableCell>

                    <StyledTableCell align="left">
                      {JSON.parse(item.branch).branchName}
                    </StyledTableCell>
                    <StyledTableCell align="left">{item.amount}</StyledTableCell>
                    <StyledTableCell align="left">{item.duration}</StyledTableCell>
                    <StyledTableCell align="left">{item.commission}</StyledTableCell>
                    <StyledTableCell align="left">{item.unit}</StyledTableCell>
                    <StyledTableCell align="">
                      <UserMoreMenu
                        parent="volume-agreement"
                        setVolumeCommissionEdit={setVolumeCommissionEdit}
                        setDeleteConfirm2={setDeleteConfirm2}
                        itemListVolume={item}
                        indexValueVolume={index}
                        volumeEditDialogOpen={volumeEditDialogOpen}
                        volumeDeleteDialogOpen={volumeDeleteDialogOpen}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default VolumeCommission;
